<template>
  <div class="wrapper">
    <div class="container">
      <div class="content px-5 py-4">
        <div class="title community-title-1 mt-3">{{ $t('community-title-1') }}</div>
        <div class="title">{{ $t('community-title-2') }}</div>
        <p class="my-3">
          {{ $t('community-description') }}
        </p>
        <MainButton @click="handleButtonClick">{{ $t('community-signup-button') }}</MainButton>
      </div>
    </div>
  </div>
</template>


<script setup>
import MainButton from '@/components/Common/Buttons/MainButton.vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { locale } = useI18n();
const router = useRouter();

const handleButtonClick = () => {
  if (locale.value === 'en') {
    router.push({ name: 'subscribe' });
  } else {
    router.push({ name: 'survey' });
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  color: #fff;
  background: #6B6B9C url('~@/assets/images/mbg.png') no-repeat right;
  background-size: contain;
  padding: 50px 0;

  .content {
    width: 50%;
    @media (max-width: 992px) {
      width: 100%;
    }
  }
}


@media (max-width: 992px) {
  .wrapper {
    background-size: cover;
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 32px 0 40px;
  }
  .content {
    padding: 1rem !important;
  }
  .title {
    font-size: 26px;
    line-height: 1.2;
  }

  .community-title-1 {
    font-size: 17px;
    line-height: 1.28;
  }
  p {
    font-size: 13px;
  }
}

.title {
  font-size: 40px;
  font-family: $font-thin;
  font-weight: 100;
  line-height: 1;
}

/*
 * nowrap was unconditional here and loaded after the mobile @media block, so it always overrode wrapping on phones
 * (and any parent :deep() rules). Keep single-line only when the 50% column layout has room (~desktop).
 */
.community-title-1 {
  overflow-wrap: break-word;
}

@media (min-width: 993px) {
  .community-title-1 {
    white-space: nowrap;
  }
}

p {
  font-size: 13px;
}
</style>